import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const posterBlockWrapperResponsive = media.tablet`
   padding: 10px 19px 15px;
`;

const posterBlockImageMobile = media.phone`
    max-height: 100px;
`;

export const PosterBlockWrapper = styled.div`
  ${posterBlockWrapperResponsive}
`;

export const PosterBlockContainer = styled.div`
  max-width: 400px;
  display: flex;
  justify-content: space-between;

  img {
    display: block;
    max-height: 120px;
    max-width: 100%;
    object-fit: contain;
    ${posterBlockImageMobile};
  }
`;

export const Row = styled.div`
  &:first-of-type {
    margin-bottom: 10px;
  }
`;

const posterPreviewResponsive = media.desktop_small`
  width: 144px;
  margin-bottom: 0;
`;

export const PosterPreview = styled.div`
  width: calc(50% - 19.5px);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 26px;
  ${posterPreviewResponsive};
`;

export const PosterPreviewImageWrapper = styled.div`
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 4px;
    border: 1px solid rgba(1, 83, 130, 0.2);
  }
`;

const posterButtonMobile = media.phone`
  height: 40px;
  font-size: 14px;  
`;

export const PosterButton = styled(ButtonLoader)`
  padding: 0 8px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  ${posterButtonMobile};
`;

export const PosterButtonsWrapper = styled.div<{ disabled?: boolean }>`
  width: calc(50% - 9.5px);

  ${({ disabled }) =>
    disabled &&
    css`
      ${PosterButton} {
        color: #919eaa;
        pointer-events: none;

        &* {
          cursor: default;
        }
      }
    `}
`;
